import { Currency } from '@app/core/models/customer.models';
import { arraySnakeToCamelCase } from '@app/core/utilities/string.utilities';
import { DefaultBidValueInEUR, TargetingBidAPIMapping, TargetingBidGroups } from './bids.constants';
import { AdPlatform, AdPlatformType } from '@app/core/models/common.models';
import { CampaignCreationAdgroup } from '@app/campaign-creation/shared/campaign-creation.models';
import { numberToMicros } from '@app/core/utilities/number.utilities';
import { CriterionAdditionCriterionType } from '@app/criterion-addition/shared/models/criterion-addition.models';

export function transformation(data: any[]) {
  data = arraySnakeToCamelCase(data).map((item: any) => ({
    productId: item.adspertProductId,
    price: item.price,
    id: item.adspertProductId,
    title: item.title,
    imageUrl: item.imageUrl,
    asin: item.amzAsin,
    parentAsin: item.amzParentAsin,
    inStock: item.inStock,
    sku: item.amzSku,
  }));

  return data;
}

export function selectedDataTransformation(data: any[], allItems: any[]) {
  if (!data?.length) return data;

  return data
    .filter(({ id }) => allItems.find((e) => id === e.productId))
    .map((d) => {
      const item: any = allItems.find((e) => d.id === e.productId);
      return {
        ...d,
        productId: item.productId,
        price: item.price,
        id: item.productId,
        imageUrl: item.imageUrl,
        parentAsin: item.amzParentAsin,
        inStock: item.inStock,
      };
    });
}

export function SuggestedTargetBidValue(
  currency: Currency,
  rates: Record<Currency, number>,
  val = DefaultBidValueInEUR,
) {
  return val * rates[`EUR-${currency}`];
}

export function canCreateCampaign(account: { platform: AdPlatformType | AdPlatform }) {
  return [AdPlatformType.Amazon, AdPlatformType.Walmart].includes(account?.platform as AdPlatformType);
}

export function parseAdGroupsForCreate(adgroups: CampaignCreationAdgroup[], platform: AdPlatform): any[] {
  const isAmazon = platform === AdPlatformType.Amazon;
  const isWalmart = platform === AdPlatformType.Walmart;

  return adgroups.map((adgroup) => ({
    ...(adgroup.adgroupMutateId != null ? { adgroupMutateId: adgroup.adgroupMutateId } : {}),
    name: adgroup.name,
    ...(isAmazon
      ? {
          defaultMaxCpc: numberToMicros(adgroup.defaultBid),
          targetBids: TargetingBidGroups.reduce((acc, bid) => {
            if (adgroup[bid].enable)
              acc.push({
                targetExpressions: [
                  {
                    type: TargetingBidAPIMapping[bid],
                  },
                ],
                bid: numberToMicros(adgroup[bid].value),
                negative: false,
                criterionType: CriterionAdditionCriterionType.Pat,
                ...(adgroup[bid].criterionMutateId ? { criterionMutateId: adgroup[bid].criterionMutateId } : {}),
              });
            return acc;
          }, []),
        }
      : {}),
    products: adgroup.products.map(({ asin, sku, title, itemId, bid, id, productAdMutateId }) => ({
      ...(productAdMutateId != null ? { productAdMutateId } : {}),
      name: title || id,
      ...(isAmazon ? { asin, sku } : {}),
      ...(isWalmart ? { itemId: itemId || id, bid } : {}),
    })),
  }));
}
